import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import MonetaryAmount from 'common/formatting/MonetaryAmount';
import { Typography } from 'common/typography';
import { convertMonetaryIntToDecimal } from 'common/utils/currencyDecimals';
import { useCampaignModuleContext } from 'modules/campaigns/context';

import { UNLIMITED_TOTAL_BUDGET_SUM } from './constants';
import CampaignFormItem from '../CampaignFormItem';
import { HelperText } from '../HelperText';

export type BudgetDetailsProps = {
  budget: number;
  'data-test-id'?: string;
};

export const BudgetDetails = ({ budget, ...props }: BudgetDetailsProps) => {
  const intl = useIntl();
  const { currency } = useCampaignModuleContext();

  return (
    <CampaignFormItem
      data-test-id={props['data-test-id']}
      title={<FormattedMessage id="campaigns.form.budget.label" />}
      value={
        <>
          <Typography.Body3>
            {budget === UNLIMITED_TOTAL_BUDGET_SUM ? (
              <FormattedMessage id="campaigns.form.budget.unlimited" />
            ) : (
              <MonetaryAmount amount={convertMonetaryIntToDecimal(budget, currency)} currency={currency} />
            )}
          </Typography.Body3>

          <HelperText text={intl.formatMessage({ id: 'campaigns.form.budget.helper-text' })} />
        </>
      }
    />
  );
};
